import { useState } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelDReportFilter } from "../../types/leveld-reports";

export function useExportParticipantCompetencyPoints() {
  const { t } = useTranslation();
  const axios = useAxios();
  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async (filter: LevelDReportFilter) => {
    if (!filter.examTermId) {
      message.warning(t("levelDReports.participantPoints.selectTerm"));
      return;
    }

    setIsExporting(true);
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
        examTermId: filter.examTermId,
      });

      const response = await axios.get(`/api/leveldreports/participant-competency-points/export?${params}`, {
        responseType: "blob",
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      
      // Generate filename from date
      const date = new Date(filter.startDate).toISOString().split("T")[0];
      link.setAttribute("download", `participant-competency-points-${date}.xlsx`);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(t("levelDReports.participantPoints.exportSuccess"));
    } catch (error) {
      console.error("Export failed:", error);
      message.error(t("levelDReports.participantPoints.exportError"));
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    isExporting,
  };
}
